import * as React from 'react'
import Lottie from 'react-lottie'
import * as flyingClock from './flyingClock.json'

type Props = {
  height?: number
  width?: number
}

export const NoWait: React.SFC<Props> = ({ height, width }) => (
  <Lottie
    options={{
      autoplay: true,
      loop: false,
      animationData: flyingClock,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    }}
    height={height}
    width={width}
  />
)

NoWait.defaultProps = {
  height: 60,
  width: 100,
}

export default NoWait
